module.exports = __webpack_public_path__ + "static/mesmer_wall-e24b4189ac6ed2bc829dc00654ff5db3.jpg";